import {
  Box,
  BoxProps,
  Container,
  ContainerProps,
  Heading,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

import { BreadcrumbsProps } from '@sphere/ui';
import { BreadcrumbsWithSeo } from './BreadcrumbsWithSeo';

type Props = BoxProps &
  Partial<BreadcrumbsProps> & {
    title?: string;
    subtitle?: string;
    containerVariant?: ContainerProps['variant'];
  };

export const PageHeader: React.FC<PropsWithChildren<Props>> = ({
  title,
  subtitle,
  pages,
  containerVariant,
  ...boxProps
}) => {
  return (
    <Box pt="space.12" pb={{ base: 'space.12', md: 'space.40' }} {...boxProps}>
      {pages && (
        <Container variant={containerVariant}>
          <BreadcrumbsWithSeo pages={pages} />
        </Container>
      )}

      {(title || subtitle) && (
        <Container mt={{ base: 'space.24', md: 'space.40' }} variant={containerVariant}>
          <SimpleGrid minChildWidth={{ base: '100%', lg: '80%' }}>
            {title && (
              <Heading as="h1" size="lg">
                {title}
              </Heading>
            )}

            {subtitle && (
              <Text color="gray.5" mt="space.12">
                {subtitle}
              </Text>
            )}
          </SimpleGrid>
        </Container>
      )}
    </Box>
  );
};
